import { ContentLayout } from "layouts";
import { CompanyMetricsTab } from "modules/deliveryCompanies";
import { useTranslation } from "react-i18next";
import { ClipLoader } from "react-spinners";

import { useCurrentPortalUser } from "../../hooks";

import styles from "./CompanyDashboard.module.scss";

const CompanyDashboard = () => {
  const { t } = useTranslation();
  const { company, isLoading } = useCurrentPortalUser();

  if (isLoading || !company?.id) {
    return (
      <div className={styles.dashboard__loader}>
        <ClipLoader size={30} color="#fb3973" />
      </div>
    );
  }

  return (
    <ContentLayout title={t("Dashboard")}>
      <CompanyMetricsTab companyId={company.id} />
    </ContentLayout>
  );
};

export default CompanyDashboard;
